import { render, staticRenderFns } from "./CDWheelChart.vue?vue&type=template&id=6c9a23dd"
import script from "./CDWheelChart.vue?vue&type=script&lang=ts"
export * from "./CDWheelChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports